var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 896,
    viewBox: "0 0 414 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "shape-8",
    d: "M667.397 693.683C503.835 1225.99 -226.162 986.674 -304.543 502.644C-366.581 119.461 -391.162 -176.577 -120.2 -279.057C28.274 -335.2 190.36 -302.281 298.645 -201.551C485.547 -27.6782 782.231 319.928 667.397 693.683Z",
    fill: "#FF9514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "shape-7",
    d: "M591.786 637.615C449.427 1100.92 -185.938 892.624 -254.158 471.341C-308.155 137.831 -329.549 -119.831 -93.7125 -209.026C35.5145 -257.891 176.589 -229.24 270.837 -141.567C433.51 9.76599 691.734 312.311 591.786 637.615Z",
    fill: "#FF9E27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "shape-6",
    d: "M535.001 573.859C412.003 980.21 -144.774 795.117 -205.914 424.953C-254.297 131.89 -273.913 -94.3944 -67.8239 -171.896C45.1156 -214.371 168.658 -188.737 251.444 -111.433C394.341 22.0134 621.367 288.529 535.001 573.859Z",
    fill: "#FFA639"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "shape-5",
    d: "M475.767 505.012C372.112 854.381 -106.06 692.519 -160.102 373.499C-202.884 120.929 -220.71 -74.0236 -44.3398 -139.852C52.2841 -175.916 158.339 -153.294 229.663 -86.3585C352.723 29.1691 548.54 259.699 475.767 505.012Z",
    fill: "#FE9C4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "shape-4",
    d: "M421.4 446.297C337.089 738.685 -62.4606 600.079 -109.422 332.178C-146.603 120.099 -162.639 -43.5206 -16.0335 -97.682C64.303 -127.355 152.826 -107.752 212.66 -51.1653C315.961 46.5018 480.581 241.003 421.4 446.297Z",
    fill: "#FC905C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "shape-3",
    d: "M364.599 382.515C299.66 617.903 -21.2851 502.527 -61.1778 285.79C-92.7566 114.203 -107.003 -18.0847 9.85524 -60.5537C73.8761 -83.8162 144.912 -67.2247 193.284 -21.0067C276.776 58.7224 410.187 217.238 364.599 382.515Z",
    fill: "#FB876A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "shape-2",
    d: "M307.815 318.759C262.237 497.191 19.8799 405.019 -12.9324 239.401C-38.9268 108.28 -51.3659 7.35077 35.7729 -23.4444C83.5065 -40.3155 137.01 -26.7425 173.92 9.10728C237.608 70.9688 339.821 193.455 307.815 318.759Z",
    fill: "#FA776D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "shape-1",
    d: "M254.834 281.734C222.784 407.435 52.065 342.427 28.9086 225.733C10.5637 133.345 1.77442 62.2328 63.138 40.5607C96.7522 28.6877 134.439 38.2656 160.445 63.5337C205.318 107.136 277.341 193.461 254.834 281.734Z",
    fill: "#F86459"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.88892f54.svg";
export { ForwardRef as ReactComponent };